import { render, staticRenderFns } from "./MillDash.vue?vue&type=template&id=f38a88a8"
import script from "./MillDash.vue?vue&type=script&lang=ts"
export * from "./MillDash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports